export default "__VITE_PUBLIC_ASSET__94c56148__"